const topicTags = [
  { tag: '每日大赛入口', count: '12.8万', hot: true },
  { tag: '每日大赛网址', count: '9.6万', hot: true },
  { tag: 'APP下载教程', count: '8.3万', hot: true },
  { tag: 'iOS安装', count: '6.7万', hot: false },
  { tag: 'Android安装', count: '6.1万', hot: false },
  { tag: '备用网址', count: '5.4万', hot: false },
  { tag: '访问异常', count: '4.9万', hot: false },
  { tag: '注册教程', count: '4.2万', hot: false },
  { tag: '最新入口', count: '3.8万', hot: true },
];

export default function Topics() {
  return (
    <section id="topics" className="py-14 md:py-20 bg-background-50">
      <div className="max-w-[1280px] mx-auto px-4 md:px-6">
        <div className="text-center mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            热门话题
          </h2>
          <p className="text-sm text-foreground-500 max-w-lg mx-auto">
            每日大赛用户最关注的话题标签与讨论热度一览
          </p>
        </div>

        <div className="max-w-3xl mx-auto">
          <div className="flex flex-wrap gap-3 justify-center">
            {topicTags.map((topic, idx) => (
              <a
                key={idx}
                href="#cards"
                className={`inline-flex items-center gap-2 px-4 py-2.5 rounded-full border text-sm font-medium transition-all duration-300 ${
                  topic.hot
                    ? 'bg-primary-50 border-primary-200 text-primary-700 hover:bg-primary-100'
                    : 'bg-background-100 border-background-200 text-foreground-600 hover:border-primary-200 hover:text-primary-600'
                }`}
              >
                {topic.tag}
                <span className={`text-xs px-2 py-0.5 rounded-full ${
                  topic.hot
                    ? 'bg-primary-200/70 text-primary-700'
                    : 'bg-background-200 text-foreground-400'
                }`}>
                  {topic.count}
                </span>
                {topic.hot && (
                  <i className="ri-fire-fill text-accent-500 text-xs"></i>
                )}
              </a>
            ))}
          </div>
        </div>
      </div>
    </section>
  );
}